import React from "react";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="nav-logo">Parth Suri</div>
      <div className="nav-links">
        <a href="#home">Home</a>
        <a href="#about">About</a>
        <a href="#experience">Experience</a>
        <a href="#certifications">Certifications</a>
        <a href="#projects">Projects</a>
        <a href="#skills">Skills</a>
        <a href="#testimonials">Testimonials</a>
        <a href="#contact">Contact</a>
      </div>
    </nav>
  );
}

export default Navbar;
